import { Injectable } from '@angular/core';
import { ITextEditorLinkAttachment } from '@fi-shared/fi-text-editor/fi-text-editor';
import { AppTextService } from '@fi-shared/app-text';
import { TextEditorInsertEmbedVideoDialogComponent } from '@fi-shared/fi-text-editor/fi-text-editor-insert-embed-video/text-editor-insert-embed-video-dialog.component';
import { FiDialogsService } from '@fi-shared/fi-dialogs';
import { TextEditorAttachmentType } from '@fi-shared/fi-text-editor/fi-text-editor-attachment/text-editor-attachment-type';
import { isDefined } from '@uirouter/core';

@Injectable()
export class TextEditorInsertEmbedVideoService {
    constructor(
        private fiDialogsService: FiDialogsService,
        private appTextService: AppTextService,
    ) {}

    private insertEmbedVideo(attachment?: ITextEditorLinkAttachment) {
        const dialogRef = this.fiDialogsService.custom({
            headerText: this.appTextService.get('text_editor.insert_video'),
            yesButtonText: this.appTextService.get('done'),
            contentComponentRef: TextEditorInsertEmbedVideoDialogComponent,
            contentComponentData: attachment ? attachment.Url : undefined,
        });
        return dialogRef;
    }

    openInsertEmbedVideoDialog(
        attachment: ITextEditorLinkAttachment,
        args?: {
            existingLinkAttachments?: ITextEditorLinkAttachment[];
            onYesButtonClick?: (attachment: ITextEditorLinkAttachment) => void;
            onNoButtonClick?: () => void;
            afterClosed?: () => void;
        },
    ) {
        this.insertEmbedVideo(attachment)
            .onYesButtonClick((newUrlData) => {
                if (!attachment) {
                    attachment = {
                        LinkType: TextEditorAttachmentType.Youtube,
                    };
                }
                attachment.Url = newUrlData.url;

                if (isDefined(args?.existingLinkAttachments)) {
                    const existingLinkAttachments = args.existingLinkAttachments;
                    const existingLinkAttachmentIdx = existingLinkAttachments.findIndex((item) => item === attachment);
                    if (existingLinkAttachmentIdx === -1) {
                        existingLinkAttachments.push(attachment);
                    } else {
                        existingLinkAttachments[existingLinkAttachmentIdx] = Object.assign({}, attachment);
                    }
                }

                if (isDefined(args?.onYesButtonClick)) {
                    args?.onYesButtonClick(attachment);
                }
            })
            .onNoButtonClick(() => {
                if (isDefined(args?.onNoButtonClick)) {
                    args?.onNoButtonClick();
                }
            })
            .afterClosed(() => {
                if (isDefined(args?.afterClosed)) {
                    args?.afterClosed();
                }
            });
    }
}
